import React from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';

function Card(props) {
  const { ref, className, childrenClassName, children, listMode, ...rest } = props;
  return (
    <div className={cx(styles.card, { [styles.listMode]: listMode }, className)} {...rest}>
      <div className={cx(styles.container, childrenClassName)}>{children}</div>
    </div>
  );
}

export default Card;
